"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var mapStateToProps = function (state) {
    return __assign(__assign({}, state.hfilter), { hasBoundary: state.mapsearch.viewport && state.mapsearch.camera ? state.mapsearch.viewport.zoom > state.mapsearch.camera.zoom : false });
};
var mapDispatchToProps = function (dispatch) { return ({
    onSortOpenClicked: function () { return dispatch(HfilterAction_1.default.setSortOpen(true)); },
    onShowMapClick: function () { return dispatch(HfilterAction_1.default.setMapActive(true)); },
    onHideMapClick: function () { return dispatch(HfilterAction_1.default.setMapActive(false)); },
    onClearBoundaryClick: function () { return dispatch(HfilterAction_1.default.onClearBoundaryClick()); },
}); };
var fbar = function (props) {
    var selectedOption = props.sortOptions.find(function (it) { return it.selected; });
    var sort = selectedOption ? selectedOption.name : props.sortOptions[0].name;
    var renderClearBoundary = function (props) {
        return (React.createElement("a", { className: "c-fbar__sidebtn", onClick: props.onClearBoundaryClick, style: { cursor: 'pointer' } }, props.t.clearBoundary));
    };
    var renderMapListToggle = function (props) {
        return (React.createElement("a", { className: "c-fbar__sidebtn", onClick: props.mapActive ? props.onClearBoundaryClick : props.onShowMapClick, style: { cursor: 'pointer' } }, props.mapActive ? props.t.list : props.t.map));
    };
    return (React.createElement("div", { className: "c-fbar" },
        React.createElement("div", { className: "c-fbar__main" },
            React.createElement("button", { onClick: props.onSortOpenClicked, className: "c-fbar__action" },
                sort,
                "\u00A0 ",
                React.createElement("span", { className: "fal fa-chevron-down" }))),
        React.createElement("div", { className: "c-fbar__side" },
            props.hasBoundary ? renderClearBoundary(props) : null,
            renderMapListToggle(props))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(fbar);
